import axios from "../base/axios.js";

const baseUrl = '/longstron/applet/programme';

// 查询列表
export function queryLimit(data) {
  return axios.post(baseUrl + '/queryLimit', data);
}

// 获取详情
export function getById(id) {
  return axios.get(baseUrl + `/${id}`);
}
